import React, { useEffect } from "react";
import { loadStyles } from "../../../utils/cssLoader";
import { truncateText, formatRssDate } from "../../../utils/interactivesHelper";
import NextImage from "../../common/NextImage";

const SERVICE_ICONS = {
  twitter:   "🐦",
  youtube:   "▶",
  instagram: "📸",
  rss:       "📰",
};

/**
 * Feed post card. Handles both loop-feed JSON items and classic RSS items.
 * Item shape: { title, link, description, pubDate, image, author, authorImage, service }
 */
const RssCard = ({
  item = {},
  showImage = true,
  showDate = true,
  showDescription = true,
  descMaxLen = 140,
  loadCSS = true,
  onClick = null,
}) => {
  useEffect(() => {
    if (loadCSS === true || loadCSS === "true") {
      loadStyles("interactivesCard");
    }
  }, [loadCSS]);

  const { title, link, description, pubDate, image, video, author, authorImage, service } = item;

  // Need at least a title or description to render
  if (!title && !description) return null;

  const displayTitle = title || truncateText(description, 80);
  const displayDesc  = title ? description : null; // don't repeat if title IS the description

  return (
    <div
      className={`interactives-card interactives-card--rss${service ? ` interactives-card--${service}` : ""}`}
      onClick={onClick}
      style={onClick ? { cursor: "pointer" } : undefined}
    >

      {showImage && image && (
        <div className="interactives-card__image-wrap">
          <NextImage
            src={image}
            alt={displayTitle}
            clz="interactives-card__image"
            fill
            objectFit="cover"
          />
          {video && <span className="interactives-card__play-badge">▶</span>}
        </div>
      )}

      <div className="interactives-card__body">

        {/* Author row */}
        {author && (
          <div className="interactives-card__author">
            {authorImage && (
              <NextImage
                src={authorImage}
                alt={author}
                clz="interactives-card__author-img"
                width={20}
                height={20}
              />
            )}
            <span className="interactives-card__author-name">{author}</span>
            {service && SERVICE_ICONS[service] && (
              <span className="interactives-card__service" title={service}>
                {SERVICE_ICONS[service]}
              </span>
            )}
          </div>
        )}

        <span className="interactives-card__title">{displayTitle}</span>

        {showDate && pubDate && (
          <span className="interactives-card__date">{formatRssDate(pubDate)}</span>
        )}

        {showDescription && displayDesc && (
          <p className="interactives-card__desc">
            {truncateText(displayDesc, descMaxLen)}
          </p>
        )}

      </div>
    </div>
  );
};

export default RssCard;
